import React from "react";
import { Table } from "antd";

const Datatable = ({
  columns,
  dataSource,
  onChange,
  summary,
  loading,
  footer,
}) => {
  const hasData = Array.isArray(dataSource) && dataSource.length > 0;

  return (
    <Table
      rowKey={(_, index) => index}
      bordered
      size="small"
      className="table-sm small-font"
      columns={columns}
      dataSource={dataSource}
      scroll={{ x: "max-content", ...(hasData ? { y: "max-content" } : {}) }}
      pagination={false}
      onChange={onChange}
      summary={summary}
      loading={loading}
      footer={footer}
    />
  );
};

export default Datatable;
